import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled, { keyframes } from "styled-components";
import {
  NFT_SMART_CONTRACT_ADDRESS,
  POLYGON_CHAIN_ID_HEX,
  POLYGON_TESTNET_CHAIN_ID_HEX,
} from "./constants";

import "./styles/App.css";
import blockchainImage from "./assets/images/blockchain-background.png";
import discordLogo from "./assets/images/discord-logo.svg";
import osLogo from "./assets/images/os-logo.svg";
import i1 from "./assets/images/nft.gif";

export const StyledButton = styled.button`
  border-radius: 50px;
  border: none;
  background-color: #ffffff;
  padding: 0.5em 1em;
  font-weight: bold;
  color: #000000;
  width: auto;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
  font-family: "Montserrat-Black";
  font-style: italic;
  font-size: 1em;
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);

  border-top: 2px solid grey;
  border-right: 2px solid grey;
  border-bottom: 2px solid grey;
  border-left: 4px solid black;
  background: transparent;
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledImg = styled.img`
  width: 100%;
  height: auto;
  transition: width 0.5s;
  transition: height 0.5s;
`;
const Footer = () => (
  <s.Container
    jc={"center"}
    ai={"center"}
    style={{ width: "80%", paddingTop: "3em" }}
  >
    <s.TextDescription style={{ textAlign: "center", fontSize: 11 }}>
      POWERED BY{" "}
      <a
        href="https://corplite.com/"
        style={{
          color: "white",
          textStyle: "underline",
          fontWeight: "bold",
        }}
      >
        CORPLITE
      </a>
    </s.TextDescription>
  </s.Container>
);

const Disclaimer = () => (
  <s.Container jc={"center"} ai={"center"} className="disclaimer">
    <s.TextDescription style={{ textAlign: "center", fontSize: 11 }}>
      PLEASE MAKE SURE YOU ARE CONNECTED TO THE RIGHT NETWORK (POLYGON MAINNET)
      AND ARE USING THE CORRECT ADDRESS. PLEASE NOTE: ONCE YOU MAKE THE
      PURCHASE, YOU CANNOT UNDO THIS ACTION
    </s.TextDescription>
    <s.TextDescription style={{ textAlign: "center", fontSize: 11 }}>
      WE HAVE SET THE GAS LIMIT TO 285000 FOR THE CONTRACT TO SUCCESSFULLY MINT
      YOUR NFT. WE RECOMMEND THAT YOU DON’T CHANGE THE GAS LIMIT.
    </s.TextDescription>
  </s.Container>
);

const Features = () => (
  <s.Container
    jc={"flex-start"}
    ai={"center"}
    flex={1}
    image={blockchainImage}
    className="feature-container"
  >
    {" "}
    <ResponsiveWrapper style={{ justifyContent: "space-between" }}>
      <s.Container jc={"flex-start"} ai={"center"} style={{ flexBasis: "24%" }}>
        <div
          style={{
            textAlign: "start",
            fontFamily: "Montserrat",
            fontStyle: "italic",
          }}
        >
          <s.TextTitle
            style={{
              fontFamily: "Montserrat-Black",
              width: "7em",
            }}
          >
            PURCHASING YOUR NFT
          </s.TextTitle>
          <s.SpacerMedium />
          <s.TextDescription style={{ fontFamily: "Montserrat-Black" }}>
            AT LAUNCH DATE, WE WILL OPEN THE GATES TO THE SNKR VAULT.
          </s.TextDescription>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            ENTER THROUGH THE WEBSITE{" "}
            <span style={{ fontFamily: "Montserrat-Black" }}>
              SNKR.CORPLITE.COM
            </span>{" "}
            TO PURCHASE YOUR NFT.
          </s.TextDescription>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            LIKE ANY OTHER NFT PROJECT, YOU WILL NEED TO LOAD YOUR METAMASK WITH
            THE RIGHT CURRENCY{" "}
            <span style={{ fontFamily: "Montserrat-Black" }}>
              (30 MATIC AKA ‘POLYGON’).
            </span>
          </s.TextDescription>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            ONCE CONNECTED,{" "}
            <span style={{ fontFamily: "Montserrat-Black" }}>
              PRESS CONNECT AND AUTHORIZE
            </span>{" "}
            YOUR TRANSACTION.
          </s.TextDescription>
        </div>
      </s.Container>
      <s.SpacerLarge />
      <s.Container jc={"flex-start"} ai={"center"} style={{ flexBasis: "24%" }}>
        <div
          style={{
            textAlign: "start",
            fontFamily: "Montserrat",
            fontStyle: "italic",
          }}
        >
          <s.TextTitle
            style={{
              fontFamily: "Montserrat-Black",
              width: "7em",
              lineHeight: "1.25em",
            }}
          >
            CLAIM YOUR REWARDS{" "}
          </s.TextTitle>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            ONCE PURCHASED, YOU WILL BE ABLE TO{" "}
            <span style={{ fontFamily: "Montserrat-Black" }}>
              CLAIM YOUR $120
            </span>{" "}
            SNEAKER LAUNDRY GIFT VOUCHER WHICH CAN BE USED ONLINE AND IN STORE.
          </s.TextDescription>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            THE WEBSITE WILL DETECT THE NFT IN YOUR WALLET ALLOWING YOU TO{" "}
            <span style={{ fontFamily: "Montserrat-Black" }}>
              ACCESS A MASTERCLASS
            </span>{" "}
            OF SNKR MOD, CLEAN AND REPAIR VIDEOS.
          </s.TextDescription>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            HOLDING THE NFT AUTOMATICALLY ENTERS YOU INTO{" "}
            <span style={{ fontFamily: "Montserrat-Black" }}>
              A DRAW TO WIN LIMITED EDITION REGULAR PRIZES.
            </span>{" "}
          </s.TextDescription>
        </div>
      </s.Container>
      <s.SpacerLarge />
      <s.Container jc={"flex-start"} ai={"center"} style={{ flexBasis: "24%" }}>
        <div
          style={{
            textAlign: "start",
            fontFamily: "Montserrat",
            fontStyle: "italic",
          }}
        >
          <s.TextTitle
            style={{
              fontFamily: "Montserrat-Black",
              width: "5em",
            }}
          >
            RESELL & HODL
          </s.TextTitle>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            GIVE OTHERS A CHANCE TO PARTICIPATE BY LISTING YOUR NFT ON
            MARKETPLACES LIKE OPENSEA.IO
          </s.TextDescription>
          <s.SpacerMedium />
          <s.TextDescription style={{}}>
            <span style={{ fontFamily: "Montserrat-Black" }}>
              RESELL, TRADE AND EARN LIMITED EDITION REWARDS
            </span>{" "}
            BY HOLDING YOUR NFTs.
          </s.TextDescription>
        </div>
      </s.Container>
    </ResponsiveWrapper>{" "}
    <s.SpacerLarge />
    <Footer />
    <s.SpacerLarge />
  </s.Container>
);

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const hasLoaded = data.hasLoaded;

  const [feedback, setFeedback] = useState("");
  const [claimingNft, setClaimingNft] = useState(false);
  const [gasPrice, setGasPrice] = useState("");
  const [totalMinted, setTotalMinted] = useState(0);
  const [gasEstimated, setGasEstimated] = useState(false);

  const claimNFTs = (_amount) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("MINTING IN PROGRESS...");
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(blockchain.account, _amount)
      .send({
        gasLimit: "285000",
        to: NFT_SMART_CONTRACT_ADDRESS,
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((30 * _amount).toString(), "ether"),
        // gasPrice: gasPrice // After EIP-1559, need to set priority fee as well as gas price, using just gasPrice will set both
        maxPriorityFeePerGas: gasPrice, // Most transactions use the same max priority fee as the gas price
        maxFeePerGas: gasPrice,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("SOMETHING WENT WRONG.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback("MINTING SUCCESS!");
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  const setDynamicGas = (price) => {
    const currentGas = Number(blockchain.web3.utils.fromWei(price, "gwei"));
    // Round up number here to prevent the gas string from being too long and causing the subsequent conversion to fail
    const newGas = (Math.round((currentGas + 5) * 100) / 100).toString();
    setGasPrice(blockchain.web3.utils.toWei(newGas, "gwei"));
    setGasEstimated(true);
  };

  useEffect(() => {
    if (hasLoaded) {
      setTotalMinted(data.totalSupply);
      blockchain.web3.eth.getGasPrice().then(setDynamicGas);
    }
  }, [hasLoaded]);

  // Prompts user to switch to the polygon network on refresh
  useEffect(() => {
    const switchNetwork = async () =>
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: POLYGON_CHAIN_ID_HEX }], // chainId must be in hexadecimal numbers
      });
    switchNetwork();
  }, []);

  return (
    <s.Screen style={{ backgroundColor: "var(--black)" }}>
      <div
        style={{
          padding: 30,
          backgroundColor: "white",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: 44,
            color: "black",
            fontFamily: "Montserrat-Black",
            fontStyle: "italic",
          }}
        >
          MINT YOUR <span className="gradient">HOLOGRAPHIC</span> VAULT KEY
        </div>
      </div>

      <s.Container flex={1} ai={"center"} style={{ padding: "0 2.5em" }}>
        <s.SpacerMedium />

        <div className="home-container">
          <a className="home" href="https://snkr.corplite.com/">
            HOME
          </a>
        </div>
        <s.SpacerMedium />
        <ResponsiveWrapper flex={1}>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg
              alt={"Sneaker Laundry Holographic Vault Key NFT"}
              src={i1}
            />
            <s.SpacerMedium />
            {/* <s.TextTitle
              style={{
                textAlign: "center",
                fontFamily: "Montserrat-Black",
                fontStyle: "italic",
              }}
            >
              {hasLoaded && (
                <span>{totalMinted.toLocaleString("en-US")}/10,000</span>
              )}
            </s.TextTitle> */}
          </s.Container>
          <s.SpacerMedium />
          <s.Container
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{ padding: 0 }}
          >
            {/* TODO: Get Max Supply from Smart Contract */}
            {Number(data.totalSupply) === 10000 ? (
              <>
                <s.TextTitle style={{ textAlign: "center" }}>
                  THE SALE HAS ENDED.
                </s.TextTitle>
                <s.SpacerSmall />
                {/* <s.TextDescription style={{ textAlign: "center" }}>
                  You can still find Sneaker Laundry on{" "}
                  <a
                    target={"_blank"}
                    href={"https://opensea.io/collection/nerdy-coder-clones"}
                  >
                    Opensea.io
                  </a>
                </s.TextDescription> */}
              </>
            ) : (
              <div
                className="mint-container"
                style={{
                  fontFamily: "Montserrat",
                  fontStyle: "italic",
                }}
              >
                <s.TextTitle
                  style={{
                    fontFamily: "Montserrat-Black",
                  }}
                >
                  EACH NFT COSTS 30 MATIC
                </s.TextTitle>
                <s.SpacerMedium />
                <s.TextDescription style={{}}>
                  EXCLUDING GAS FEES.
                </s.TextDescription>
                <s.TextDescription style={{}}>
                  MAYBE IT'S YOUR LUCKY DAY.
                </s.TextDescription>
                <s.SpacerMedium />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container className="mint-container" jc={"center"}>
                    <s.TextDescription style={{}}>
                      CONNECT TO THE POLYGON NETWORK
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      <span>CONNECT</span>
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription style={{ textAlign: "center" }}>
                          {blockchain.errorMsg.toUpperCase()}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <s.Container
                    ai={"center"}
                    jc={"center"}
                    className="mint-container"
                  >
                    {hasLoaded && gasEstimated ? (
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs(1);
                          getData();
                        }}
                      >
                        {claimingNft ? "BUSY" : "MINT 1"}
                      </StyledButton>
                    ):
                    <Spinner />}
                    <s.SpacerMedium />
                    <s.TextDescription style={{}}>{feedback}</s.TextDescription>
                  </s.Container>
                )}
                <s.Container
                  fd={"row"}
                  className="mint-container"
                  style={{ paddingTop: "1.5em" }}
                >
                  <a
                    href="https://discord.gg/Q5Wa8z3dah"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="logo"
                      src={discordLogo}
                      alt="Discord Logo"
                    />
                  </a>
                  <s.SpacerMedium />
                  {/* TODO: Update to Mainnet URL before deploying */}
                  <a
                    href="https://opensea.io/collection/sneaker-laundry-nft"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img className="logo" src={osLogo} alt="OpenSea Logo" />
                  </a>
                </s.Container>
              </div>
            )}
          </s.Container>
        </ResponsiveWrapper>
        <s.SpacerLarge />
        <Disclaimer />
        <s.SpacerLarge />
        <Features />
      </s.Container>
    </s.Screen>
  );
}

export default App;
